import randomColor from "randomcolor";

import { HexColor } from "@mapmycustomers/shared/types/AnyColor";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import stringHash from "@mapmycustomers/shared/util/hash/stringHash";

const colorMap = new Map<Identified["id"], HexColor>();

const getRandomColor = (id: Identified["id"]): HexColor => {
  if (!colorMap.has(id)) {
    const color = randomColor({
      format: "hex",
      luminosity: "light",
      seed: (stringHash(id.toString()) * 0xdeadbeef) & 0xffffffff,
    });
    colorMap.set(id, color as HexColor);
  }

  return colorMap.get(id)!;
};

export default getRandomColor;
